var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileLinesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f27d42;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64,0C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h256c35.3,0,64-28.7,64-64V160h-128c-17.7,0-32-14.3-32-32V0H64Zm192,0v128h128L256,0ZM112,256h160c8.8,0,16,7.2,16,16s-7.2,16-16,16H112c-8.8,0-16-7.2-16-16s7.2-16,16-16Zm0,64h160c8.8,0,16,7.2,16,16s-7.2,16-16,16H112c-8.8,0-16-7.2-16-16s7.2-16,16-16Zm0,64h160c8.8,0,16,7.2,16,16s-7.2,16-16,16H112c-8.8,0-16-7.2-16-16s7.2-16,16-16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLinesSolid);
export default __webpack_public_path__ + "static/media/file-lines-solid.ed4384ba172ba7eef70bcb54dbcb2aa8.svg";
export { ForwardRef as ReactComponent };